// Re-export logger from core package
// This allows app-specific controllers to keep using import { logger } from "../logger"
export { logger } from '@core/utilities/logger'
